import React, {useCallback, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCButton from '../../components/Simple/SMCButton';
import SMCModal from '../../components/core/SMCModal';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useSMCErrorHandler} from '../../utils/errorUtils';
import Tree from '../PopupPages/Tree';
import Api from "../../api/SMPFetchHelper";

/**
 * Updatable editor modal
 * @param {Object} params
 * @param {Boolean} params.isOpen Is window open
 * @param {[String]} params.deafultSelected Default selected objects
 * @param {Function} params.onRequestClose Window close function
 * @param {Function} params.onSuccess Success callback
 * @param {Boolean} [params.selectMultiple] Is multiple selection allowed. Default is true
 */

function UpdatableObjectSelectModal({
                                        isOpen,
                                        deafultSelected,
                                        onRequestClose,
                                        onSuccess,
selectMultiple = true,
setUoTableDataValue
                                    }) {
    const [selectedObjects, setSelectedObjects] = useState([]);
    const [isTableDataLoading, setIsTableDataLoading] = useState(false);
    const [uoTableData, setUpdatableObjectsTableData] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [hadData, setHasData] = useState(false);
    const {t} = useTranslation();
    const {getErrorMessage} = useSMCErrorHandler();

    const loadData = useCallback(() => {
            setIsTableDataLoading(true);
            Api.getUpdatableObjects()
                .then((resp) => {
                    const uoData = resp.data.data;
                    setUpdatableObjectsTableData(uoData);
                    setUoTableDataValue(resp.data.data.children);
                    setHasData(true);
                })
                .catch(e => {
                    const errorMessage = getErrorMessage(e);
                    setErrorMessage(errorMessage);
                })
                .finally(() => {
                    setIsTableDataLoading(false);
                });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getErrorMessage]);


    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleApply = () => {
        onSuccess(selectedObjects);
    };

    return (
        <SMCModal
            loading={isTableDataLoading}
            title={t('UPDATABLE OBJECTS')}
            height={605}
            width={500}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            errorMessage={errorMessage}
            reloadData={loadData}
        >
            {hadData && <SMCModalBody lineHeight="22px" style={{paddingTop: '5px'}}>
                {
                    <Tree
                        data={uoTableData}
                        setSelectedObjects={setSelectedObjects}
                        loading={isTableDataLoading}
                        handleApply={handleApply}
                    >
                    </Tree>
                }

            </SMCModalBody>}
            <SMCModalButtonContainer>
                <SMCButton onClick={handleApply}>
                    <FontAwesomeIcon style={{marginTop: '3px', marginRight: '5px'}} color="green" icon="check"/>
                    {t('SMC_GEN_APPLY')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{marginTop: '3px', marginRight: '5px'}} color="grey" icon="times"/>
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default UpdatableObjectSelectModal;